import { ReoIcon } from '@reolink-web/components.basic';
import React from 'react';
import styles from './index.module.less';
import CompDropdownMenu from '../CompDropdownMenu';
import * as sitePath from '@/utils/function/sitePath';
import classNames from 'classnames';
import type { IDropdownMenuItem } from '../../common';
import { HeaderContext } from '../../common';

const CompHeaderAccount: React.FC = () => {
    const { userPrefile } = React.useContext(HeaderContext);
    const accountMenus = React.useMemo<IDropdownMenuItem[]>(() => {
        if (userPrefile?.email) {
            return [
                {
                    title: 'menu-dashboard',
                    link: sitePath.getOfficialSitePath('/my-account/'),
                },
                {
                    title: 'menu-orders',
                    link: sitePath.getOfficialSitePath('/my-account/orders/'),
                },
                {
                    title: 'menu-my-cloud',
                    link: sitePath.getCloudPath('/user/subscribe-plan/cloud/'),
                },
                {
                    title: 'menu-my-community',
                    link: sitePath.getCommunityPath(),
                },
                {
                    title: 'menu-logout',
                    link: sitePath.getLogoutPath(),
                },
            ];
        }

        return [
            {
                title: 'menu-sign-up',
                link: sitePath.getSignupPath(),
            },
            {
                title: 'menu-log-in',
                link: sitePath.getLoginPath(),
            },
            {
                title: 'menu-track-order',
                link: '/track-your-order/',
            },
        ];
    }, [userPrefile?.email]);

    return (
        <li className={ classNames(styles['header-action-item'], styles['account-action']) }>
            <ReoIcon
                className={ styles['header-action-item-icon'] }
                name={ 'icon-icon_person-2' } />
            <CompDropdownMenu
                className={ styles['dropdown-menu-content'] }
                menus={ accountMenus } />
        </li>
    );
};
export default CompHeaderAccount;
